import {
  AppBar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  colors,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import BG from "../../assets/images/BG.png";
import NoImage from "../../assets/images/no-image.jpg";
import ShopIcon from "../../assets/images/shop.png";
import GoldIcon from "../../assets/images/gold.png";
import DiamondIcon from "../../assets/images/diamond.png";
import CarIcon from "../../assets/images/car.png";
import HouseIcon from "../../assets/images/house.png";
import VariousIcon from "../../assets/images/differentiate.png";
import SystemDashboard from "../../assets/images/system_dashboard.png";
import SystemProduct from "../../assets/images/system_product.png";
import { makeStyles, styled } from "@mui/styles";
import {
  ArrowLeft,
  ArrowRight,
  ExpandMore,
  HorizontalRule,
  Store,
} from "@mui/icons-material";
import React, { Suspense, useEffect } from "react";
import Contact from "../../components/Contact";
import Header from "../../components/Header";
import { GradientCircularProgress } from "components/Loading";

const useStyles = makeStyles((theme) => ({
  textDescription: {
    color: "#6c6c6c",
    fontWeight: "Regular",
  },
  title: {
    color: "#212529",
    fontSize: "24px",
    fontWeight: "Semibold",
  },
  titleGreen: {
    color: "#00BA9E",
    fontSize: "24px",
    fontWeight: "Semibold",
  },
  subtitle: {
    color: "#6c6c6c",
    fontSize: "20px",
    fontWeight: "Regular",
    textAlign: "center",
  },
  textGradient: {
    background: "linear-gradient(to right, #4cb8ba, #7bd867)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

function Home() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <GradientCircularProgress />
      </Box>
    );
  }

  const cardsGroup = [
    {
      title: "Pawn shop",
      description: "กลุ่มโรงรับจำนำ",
      image: NoImage,
      icon: ShopIcon,
    },
    {
      title: "Gold shop",
      description: "กลุ่มร้านขายทองคำ",
      image: NoImage,
      icon: GoldIcon,
    },
    {
      title: "Jewelry shop",
      description: "กลุ่มร้านขายเพชร",
      image: NoImage,
      icon: DiamondIcon,
    },
    {
      title: "Various cooperatives",
      description: "กลุ่มสหกรณ์ต่าง ๆ",
      image: NoImage,
      icon: VariousIcon,
    },
    {
      title: "Car buy-sell shop",
      description: "กลุ่มร้านซื้อ-ขายรถยนต์",
      image: NoImage,
      icon: CarIcon,
    },
    {
      title: "House and land trading",
      description: "กลุ่มบริษัทซื้อขายบ้าน และที่ดิน",
      image: NoImage,
      icon: HouseIcon,
    },
  ];

  const DashboardCard = [
    { value: 0, label: "จำนวนสินค้า", icon: <Store /> },
    { value: 0, label: "จำนวนลูกค้า", icon: <Store /> },
    { value: 0, label: "ยอดขาย", icon: <Store /> },
  ];

  const features = [
    {
      title: "1. อ่านชิพบัตรประชาชน",
      description:
        "มีเครื่องอ่านชิพบัตรประชาชนได้ กรอกข้อมูลหน้าบัตร อัตโนมัติ ลดขั้นตอนการจดข้อมูล",
    },
    {
      title: "2. หมวดหมู่ค้นหาง่าย",
      description: "แยกประเภทของสินค้าที่อยู่ในร้านเป็นหมวดหมู่ค้นหาง่าย",
    },
    {
      title: "3. บันทึกลายนิ้วมือเก็บไว้ในระบบ",
      description: "บันทึกข้อมูลลายนิ้วมือเก็บไว้ในระบบได้อย่างปลอดภัย",
    },
    {
      title: "4. สรุปยอดคิดดอกเบี้ยอัตโนมัติ",
      description:
        "ไม่ต้องสรุปยอดรายรับ รายจ่าย กำไร และการคิดดอกเบี้ยด้วย ตัวเอง เพราะระบบจะคำนวณให้ทั้งหมด สามารถเลือกดูตาม วันที่ที่ต้องการได้",
    },
    {
      title: "5. เชื่อมต่อกับกล้อง",
      description:
        "เชื่อมต่อกับกล้องไว้ถ่ายบันทึกรูปสินค้า ใน 1 สินค้าสามารถ บันทึกได้มากกว่า 1 ภาพ เพื่อให้เห็นหลายๆ มุมของตัวสินค้า",
    },
    {
      title: "6. ง่ายต่อการดูข้อมูล",
      description:
        "เก็บภาพสินค้า และรายละเอียดสินค้าไว้ในที่เดียวกัน ง่ายต่อ การดูข้อมูล",
    },
    {
      title: "7. เก็บข้อมูลไว้บน Cloud Server",
      description:
        "เก็บข้อมูลทั้งหมดไว้บน Cloud Server ที่มีความปลอดภัยสูง ต่อให้เครื่องได้รับความเสียหาย แต่ข้อมูลก็ยังคงอยู่",
    },
    {
      title: "8. Scan QR Code ในการทำรายการ",
      description:
        "ระบบรองรับการสแกน QR Code ในการทำรายการต่าง ๆ อย่างสะดวก รวดเร็ว",
    },
  ];

  // เพิ่มเนื้อ content ทีหลังได้
  const quikPawnCounter = [
    {
      title: "1. โปรแกรมทำรายการหน้าเคาท์เตอร์ด้วยเครื่อง All In One",
      content: "",
    },
    {
      title: "2. หน้าเว็บหลังบ้านเพื่อดูข้อมูล",
      content: "",
    },
  ];

  const quikPawnEDC = [
    {
      title: "1. โปรแกรมทำรายการด้วยเครื่อง EDC",
      content: "",
    },
    {
      title: "2. หน้าเว็บหลังบ้านเพื่อดูข้อมูล",
      content: "",
    },
  ];

  return (
    <div className="bg-white">
      <Header /> 
      <Container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: "30px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100vw",
            height: "570px",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{ height: "100%", width: "100%", objectFit: "cover" }}
            component="img"
            src={BG}
          ></Box>
          <Box
            sx={{
              position: "absolute",
              top: "25%",
              left: "60%",
              flexDirection: "column",
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: "48px",
                fontWeight: "medium",
              }}
            >
              QuikPawn
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: "30px",
                fontWeight: "SemiBold",
                mt: 1,
              }}
            >
              โปรแกรมที่จะทำให้เรื่องการ ซื้อ-ขาย-จำนำ เป็นเรื่องง่าย
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: "30px",
                fontWeight: "SemiBold",
              }}
            >
              และไม่วุ่นวายกับเอกสารอีกต่อไป
            </Typography>
            <Button
              sx={{
                mt: 2,
                fontSize: "24px",
                fontWeight: "medium",
                borderRadius: "6px",
                border: "2px solid",
                color: "white",
                textTransform: "none",
                width: "250px",
                backgroundColor: "rgba(0, 0,0, 0.2)",
              }}
            >
              Start QuikPawn!
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            p: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              mt: 4,
            }}
          >
            <Typography className={classes.title}>QuikPawn</Typography>
            <Typography className={classes.titleGreen} sx={{ ml: 1 }}>
              WHO IT'S FOR ?
            </Typography>
          </Box>
          <Typography className={classes.subtitle}>
            พัฒนาระบบเพื่อตอบโจทย์กับธุรกิจของลูกค้าหลากหลายประเภท
            และเป็นประโยชน์ต่อบริษัทของคุณมากที่สุด
          </Typography>

          <Box
            sx={{
              flexGrow: 1,
              mt: 4,
              mb: 4,
            }}
          >
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
              sx={{ justifyContent: "center" }}
            >
              {cardsGroup.map((card, index) => (
                <Grid key={index} item xs={2} sm={4} md={4}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      border: "1px solid #efefef",
                      borderRadius: 3,
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="200"
                      image={NoImage}
                      alt="green iguana"
                    />
                    <CardContent>
                      <Grid container sx={{ alignItems: "center" }}>
                        <Grid item xs={2}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              backgroundColor: colors.grey[200],
                              borderRadius: "50%",
                              height: "60px",
                              width: "60px",
                            }}
                          >
                            <Box
                              sx={{ height: "30px", width: "30px" }}
                              component="img"
                              src={card.icon}
                              alt="icon"
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={10} sx={{ pl: 3 }}>
                          <Typography variant="h6" component="div">
                            {card.title}
                          </Typography>
                          <Typography className={classes.textDescription}>
                            {card.description}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100vw",
            height: "250px",
            backgroundImage: "linear-gradient(to right, #4cb8ba, #7bd867)",
            mt: 2,
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "row",
              px: 4,
              gap: 4,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "50%",
              }}
            >
              <Typography variant="h5" sx={{ fontWeight: "medium" }}>
                เพิ่มยอดขายด้วย
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: "medium" }}>
                QuickPawn
              </Typography>
            </Box>
            <Grid
              container
              spacing={4}
              sx={{ justifyContent: "flex-end", ml: 4 }}
            >
              {DashboardCard.map((dashboard, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: 2,
                      boxShadow: 3,
                      borderRadius: 3,
                      maxWidth: 300,
                    }}
                  >
                    <Box>
                      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                        {dashboard.value}
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        {dashboard.label}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        backgroundColor: "#4cb8ba",
                        borderRadius: "50%",
                        width: 50,
                        height: 50,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                      }}
                    >
                      {dashboard.icon}
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>

        <Box
          sx={{
            backgroundColor: "#00BA9e",
            width: "100vw",
            px: 20,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              backgroundColor: "white",
              p: 4,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              <Typography className={classes.title}>QuikPawn</Typography>
              <Typography
                className={classes.titleGreen}
                sx={{
                  ml: 1,
                }}
              >
                ADVANTAGES FEATURES
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography className={classes.subtitle}>
                ระบบบริหารจัดการอย่างครบถ้วน
                เพื่อประโยชน์ต่อบริษัทของคุณมากที่สุด
              </Typography>
            </Box>

            <Grid
              container
              spacing={2}
              sx={{ mt: 2 }}
              justifyContent={"center"}
            >
              {features.map((feature, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Box
                    sx={{
                      height: "100%",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      borderRadius: 1,
                      p: "20px",
                      border: "1px solid #efefef",
                    }}
                  >
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{
                        fontSize: "24px",
                        color: "#00BA9E",
                        fontWeight: "Regular",
                      }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#6c6c6c",
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            p: 4,
            backgroundColor: "#f9f9f9",
            width: "100vw",
            gap: 5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              mt: 2,
            }}
          >
            <Typography className={classes.title}>QuikPawn</Typography>
            <Typography className={classes.titleGreen} sx={{ ml: 1 }}>
              MANAGEMENT SYSTEM
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: 5,
                width: "80%",
              }}
            >
              <Box
                sx={{
                  width: "40%",
                  borderRadius: 1,
                  boxShadow: 3,
                }}
                component="img"
                src={SystemProduct}
              ></Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography sx={{ fontSize: "20px", fontWeight: "Semibold" }}>
                  SYSTEM ส่วนที่ 1 : สำหรับทำรายการจำนำ
                </Typography>
                <Typography
                  variant="body1"
                  className={classes.textDescription}
                  sx={{ mt: 1 }}
                >
                  ทำรายการจำนำหน้าเคาท์เตอร์จะติดตั้งเครื่อง All In One
                  เพื่อใช้ในการทำรายการจำนำ และต่อ
                  ดอกเจ้าหน้าที่เสียบบัตรประชนเข้าที่ Card Reader
                  เพื่อกรอกข้อมูลบัตรประชาชน อัตโนมัติ เก็บ ลายนิ้วมือ
                  ถ่ายรูปสินค้า ใส่รายละเอียดสินค้า และจำนวนเงินเข้าโปรแกรม
                  ข้อมูลทั้งหมดจะบัน ทึกออนไลน์...
                </Typography>
                <Button
                  sx={{
                    mt: 2,
                    fontSize: "20px",
                    fontWeight: "Semibold",
                    color: "#00BA9E",
                    width: "fit-content",
                  }}
                  startIcon={<HorizontalRule />}
                  endIcon={
                    <ArrowRight
                      sx={{
                        height: "40px",
                        width: "40px",
                      }}
                    />
                  }
                >
                  READ MORE
                </Button>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 4,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: 5,
                width: "80%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                }}
              >
                <Typography sx={{ fontSize: "20px", fontWeight: "Semibold" }}>
                  SYSTEMS ส่วนที่ 2 : สำหรับดูข้อมูลรายงาน
                </Typography>
                <Typography
                  variant="body1"
                  className={classes.textDescription}
                  sx={{ mt: 1, textAlign: "end" }}
                >
                  แอดมินล็อกอินเข้าหน้าหลังบ้านเพื่อดู Dashboard ของร้าน
                  ทั้งต้นทุน กำไร รายรับ รายจ่าย โดย โปรแกรมจะคำนวณให้อัตโนมัติ
                  เลือกวันที่ต้องการได้ และ Export ออกมาเป็นไฟล์ Excel อีกทั้ง
                  ยังสามารถดูสินค้าที่มีในร้านโดยแบ่งเป็นหมวดหมู่สินค้าต่างๆ
                  ได้อีกด้วย...
                </Typography>
                <Button
                  sx={{
                    mt: 2,
                    fontSize: "20px",
                    fontWeight: "Semibold",
                    color: "#00BA9E",
                    width: "fit-content",
                  }}
                  startIcon={
                    <ArrowLeft
                      sx={{
                        height: "40px",
                        width: "40px",
                      }}
                    />
                  }
                  endIcon={<HorizontalRule />}
                >
                  READ MORE
                </Button>
              </Box>

              <Box
                sx={{
                  width: "40%",
                  borderRadius: 1,
                  boxShadow: 3,
                }}
                component="img"
                src={SystemDashboard}
              ></Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            px: 2,
            mt: 4,
            flexDirection: "column",
            display: "flex",
            gap: 2,
            mb: 4,
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              p: 2,
              gap: 2,
            }}
          >
            <Typography className={classes.titleGreen}>
              QuikPawn สำหรับเคาท์เตอร์ที่ร้าน
            </Typography>
            <Typography className={classes.textDescription}>
              โรงรับจำนำทั่วประเทศจะสามารถใช้โปรแกรม QuikPawn ผ่านเครื่อง All In
              One ในการทำรายการต่างๆ ให้ลูกค้าได้อย่างสะดวก
              เชื่อมต่อทั้งเครื่องอ่านบัตรประชาชน เครื่องบันทึกลายนิ้วมือ
              และกล้องดิจิตัลเพื่อเก็บภาพสินค้าปลอดภัยมากกว่าเพราะบันทึกข้อมูลทั้งหมดไว้บน
              Cloud Server ที่มีความปลอดภัยสูง ต่อให้เครื่องได้รับความเสียหาย
              แต่ข้อมูลก็ยังคงอยู่
            </Typography>
            {quikPawnCounter.map((item, index) => (
              <Card
                key={index}
                sx={{
                  boxShadow: 0,
                  borderRadius: 1,
                  border: "1px solid #efefef",
                }}
              >
                <CardActionArea
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 2,
                    "&:hover": {
                      backgroundColor: "white",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: "Semibold",
                      p: 2,
                    }}
                    className={classes.textGradient}
                  >
                    {item.title}
                  </Typography>
                  <ExpandMore />
                </CardActionArea>
              </Card>
            ))}
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              p: 2,
              gap: 2,
            }}
          >
            <Typography className={classes.titleGreen}>
              QuikPawn สำหรับโรงรับจำนำสัญจร
            </Typography>
            <Typography className={classes.textDescription}>
              โปรแกรม QuikPawn
              รองรับการทำรายการสำหรับโรงรับจำนำสัญจรโดยใช้เครื่อง EDC
              ในการบันทึกข้อมูล สามารถอ่านบัตรประชาชนอัตโนมัติ
              บันทึกลายนิ้วมือได้อย่างสะดวก พร้อมกับถ่ายรูปสินค้าได้ในตัว
              และปริ้นท์สลิป QR Code รวมถึงสแกน QR Code
              เพื่อทำรายการการจำนำได้อีกด้วย
            </Typography>
            {quikPawnEDC.map((item, index) => (
              <Card
                key={index}
                sx={{
                  boxShadow: 0,
                  borderRadius: 1,
                  border: "1px solid #efefef",
                }}
              >
                <CardActionArea
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    px: 2,
                    "&:hover": {
                      backgroundColor: "white",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontWeight: "Semibold",
                      p: 2,
                    }}
                    className={classes.textGradient}
                  >
                    {item.title}
                  </Typography>
                  <ExpandMore />
                </CardActionArea>
              </Card>
            ))}
          </Box>
        </Box>
      </Container>
      <Contact />
    </div>
  );
}

export default Home;
